import "./style/fast.css";
import "./style/index.css";
import "./style/App.css";
import "./style/font-awesome.min.css";
import AppRoute from "./routes/AppRoute";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import {
  getWebUtilities,
  setCountry,
} from "./store/features/webUtilitiesSlice";
import secureLocalStorage from "react-secure-storage";
import { getPathPrefix2, validatePageSavedData } from "./function/functions";
import { VERSION_CHECK_API } from "./config/ApisCollection";

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    // Version check
    const versionCheckFunc = async () => {
      const ver_body = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      };

      await fetch(VERSION_CHECK_API, ver_body)
        .then((res) => res.json())
        .then((result) => {
          if (!result["error"]) {
            if ("fastWeb_vc" in localStorage) {
              if (localStorage.getItem("fastWeb_vc") != result._vc) {
                localStorage.clear();
                localStorage.setItem("fastWeb_vc", result._vc);
                fetchData();
              } else {
              }
            } else {
              localStorage.clear();
              fetchData();
              localStorage.setItem("fastWeb_vc", result._vc);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };

    // Survey hitting
    const fetchData = async () => {
      try {
        const country_code = await getPathPrefix2();
        const requestOption = {
          country: "us",
          ip: "122.176.113.48",
          location: "",
          device: "web",
          deviceVer: "",
          deviceToken: "",
        };

        const data = {
          ...requestOption,
          country: country_code,
        };

        await dispatch(getWebUtilities(data));
        await dispatch(setCountry(country_code));
      } catch (error) {
        console.error("Error fetching web utilities:", error);
      }
    };
    const surveyItems = secureLocalStorage.getItem("surveyItems");
    // Check if surveyItems is undefined, null, or empty
    if (!surveyItems) {
      fetchData(); // Call fetchData only when surveyItems is undefined, null, or empty
    } else if (window.location.pathname === "/") {
      versionCheckFunc();
    }

    const previous_page_local_storage = validatePageSavedData();
    if (
      previous_page_local_storage === false &&
      !window.location.pathname?.startsWith("/callback/pg/")
    ) {
      window.location.href = "/";
      // console.log(previous_page_local_storage);
    }
  }, [dispatch]);
  return (
    <div style={{ height: "100%" }}>
      <AppRoute />
    </div>
  );
}
export default App;
